import { createApiClient } from 'api/createApiClient'
import { CEREBRO_ACCESS_TOKEN } from 'const/localStorage'
import { invalidateCache } from 'reducers/cache'
import storeRegistry from 'utilities/storeRegistry'

import { shouldInvalidateCache } from './caching'

export const unscopedApiClient = createApiClient()
unscopedApiClient.interceptors.request.use((config) => {
    const accessToken = localStorage.getItem(CEREBRO_ACCESS_TOKEN)

    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
    }

    if (shouldInvalidateCache(config)) {
        storeRegistry.dispatch(invalidateCache())
    }

    return config
})
